import { createSlice } from '@reduxjs/toolkit';
import {
  _setD1TmtTmtStsId,
  _setD2TmtTmtStsId,
  _setD3TmtTmtStsId,
  _setD4TmtTmtStsId,
  _setD5TmtTmtStsId,
  _setD6TmtTmtStsId,
  _setD7TmtTmtStsId,
  _setFaceTimei1,
  _setG1TmtTmtStsId,
  _setG2TmtTmtStsId,
  _setG3TmtTmtStsId,
  _setG4TmtTmtStsId,
  _setG5TmtTmtStsId,
  _setG6TmtTmtStsId,
  _setG7TmtTmtStsId,
  _setI1TmtTmtStsId,
  _setI2TmtTmtStsId,
  _setI3TmtTmtStsId,
  _setI4TmtTmtStsId,
  _setI5TmtTmtStsId,
  _setI6TmtTmtStsId,
  _setI7TmtTmtStsId,
  _setVerEpdId,
  _setVerIcnCDC,
  _setVerPrtId,
  _setVerSapAthId,
  _setVerSapAthMaxUnits,
  _setVerSapAthMaxWkUnits,
  _setI1TmtFaceHours,
  _setFaceTimei3,
  _setFaceTimei2,
  _setFaceTimei4,
  _setFaceTimei5,
  _setFaceTimei6,
  _setFaceTimei7,
  _setSupplementalTimei1,
  _setSupplementalTimei2,
  _setSupplementalTimei3,
  _setSupplementalTimei4,
  _setSupplementalTimei5,
  _setSupplementalTimei6,
  _setSupplementalTimei7,
  _setIsValidateP3,
  _setIsCallVerifyPopup,
  _setIsTmtStsId,
  _setIsDropDownCall,
  _setIsStatusTag,
  _setCheckAdm,
  _setIntMed,
  _setIntMedId,
  _setIntMedValueId,
  // _setIsCallApi,
} from './verificationActions';
import initialState from './verificationInitialState';

// const initialState = {
//   VerificationDialogPopup: ''
// };

export const getVerificationPopupSlice = createSlice({
  name: 'getVerificationPopupSlice',
  initialState,
  reducers: {
    verificationsDialogPopupList: (state, action) => {
      state.VerificationDialogPopup = action.payload;
    },
    setVerPrtId: _setVerPrtId,
    setVerIcnCDC: _setVerIcnCDC,
    setVerEpdId: _setVerEpdId,
    setVerSapAthId: _setVerSapAthId,
    setVerSapAthMaxUnits: _setVerSapAthMaxUnits,
    setVerSapAthMaxWkUnits: _setVerSapAthMaxWkUnits,
    setI1TmtTmtStsId: _setI1TmtTmtStsId,
    setI2TmtTmtStsId: _setI2TmtTmtStsId,
    setI3TmtTmtStsId: _setI3TmtTmtStsId,
    setI4TmtTmtStsId: _setI4TmtTmtStsId,
    setI5TmtTmtStsId: _setI5TmtTmtStsId,
    setI6TmtTmtStsId: _setI6TmtTmtStsId,
    setI7TmtTmtStsId: _setI7TmtTmtStsId,
    setG1TmtTmtStsId: _setG1TmtTmtStsId,
    setG2TmtTmtStsId: _setG2TmtTmtStsId,
    setG3TmtTmtStsId: _setG3TmtTmtStsId,
    setG4TmtTmtStsId: _setG4TmtTmtStsId,
    setG5TmtTmtStsId: _setG5TmtTmtStsId,
    setG6TmtTmtStsId: _setG6TmtTmtStsId,
    setG7TmtTmtStsId: _setG7TmtTmtStsId,
    setD1TmtTmtStsId: _setD1TmtTmtStsId,
    setD2TmtTmtStsId: _setD2TmtTmtStsId,
    setD3TmtTmtStsId: _setD3TmtTmtStsId,
    setD4TmtTmtStsId: _setD4TmtTmtStsId,
    setD5TmtTmtStsId: _setD5TmtTmtStsId,
    setD6TmtTmtStsId: _setD6TmtTmtStsId,
    setD7TmtTmtStsId: _setD7TmtTmtStsId,
    setFaceTimei1: _setFaceTimei1,
    setFaceTimei2: _setFaceTimei2,
    setFaceTimei3: _setFaceTimei3,
    setFaceTimei4: _setFaceTimei4,
    setFaceTimei5: _setFaceTimei5,
    setFaceTimei6: _setFaceTimei6,
    setFaceTimei7: _setFaceTimei7,
    setSupplementalTimei1: _setSupplementalTimei1,
    setSupplementalTimei2: _setSupplementalTimei2,
    setSupplementalTimei3: _setSupplementalTimei3,
    setSupplementalTimei4: _setSupplementalTimei4,
    setSupplementalTimei5: _setSupplementalTimei5,
    setSupplementalTimei6: _setSupplementalTimei6,
    setSupplementalTimei7: _setSupplementalTimei7,
    setIsValidateP3: _setIsValidateP3,
    setIsCallVerifyPopup: _setIsCallVerifyPopup,
    setIsTmtStsId: _setIsTmtStsId,
    setIsDropDownCall: _setIsDropDownCall,
    setIsStatusTag: _setIsStatusTag,
    setCheckAdm: _setCheckAdm,
    setIntMedId: _setIntMedId,
    setIntMedValueId: _setIntMedValueId,
    // setIsCallApi: _setIsCallApi,
  },
});

export const {
  verificationsDialogPopupList,
  setVerPrtId,
  setVerIcnCDC,
  setVerEpdId,
  setVerSapAthId,
  setVerSapAthMaxUnits,
  setI1TmtTmtStsId,
  setI2TmtTmtStsId,
  setI3TmtTmtStsId,
  setI4TmtTmtStsId,
  setI5TmtTmtStsId,
  setI6TmtTmtStsId,
  setI7TmtTmtStsId,
  setG1TmtTmtStsId,
  setG2TmtTmtStsId,
  setG3TmtTmtStsId,
  setG4TmtTmtStsId,
  setG5TmtTmtStsId,
  setG6TmtTmtStsId,
  setG7TmtTmtStsId,
  setD1TmtTmtStsId,
  setD2TmtTmtStsId,
  setD3TmtTmtStsId,
  setD4TmtTmtStsId,
  setD5TmtTmtStsId,
  setD6TmtTmtStsId,
  setD7TmtTmtStsId,
  setI1TmtFaceHours,
  setFaceTimei1,
  setFaceTimei2,
  setFaceTimei3,
  setFaceTimei4,
  setFaceTimei5,
  setFaceTimei6,
  setFaceTimei7,
  setSupplementalTimei1,
  setSupplementalTimei2,
  setSupplementalTimei3,
  setSupplementalTimei4,
  setSupplementalTimei5,
  setSupplementalTimei6,
  setSupplementalTimei7,
  setIsValidateP3,
  setIsCallVerifyPopup,
  setIsTmtStsId,
  setIsDropDownCall,
  setIsStatusTag,
  setCheckAdm,
  setIntMedId,
  setIntMedValueId,
  // setIsCallApi,
} = getVerificationPopupSlice.actions;

export default getVerificationPopupSlice.reducer;
